import InteractiveCatalogPageItem from '../InteractiveCatalogPageItem';

export default class MultiStateObjectItem extends InteractiveCatalogPageItem {

    constructor() {
        super();
        this.stateObjects = [];

        this._current = 0;
    }

    goToState(stateName) {
        for (let i in this.stateObjects) {
            let stateObject = this.stateObjects[i];
            if (stateObject.stateName == stateName) {
                this._current = i;
                break;
            }
        }
    }

    goToNextState(stopInLast = false) {
        if (this._current < this.stateObjects.length - 1) {
            this._current++;
        } else if (!stopInLast) {
            this._current = 0;
        }
    }

    goToPreviousState(stopInFirst = false) {
        if (this._current > 0) {
            this._current--;
        } else if (!stopInFirst) {
            this._current = this.stateObjects.length - 1;
        }
    }

    refresh(itemDiv) {
        let currentStateName = this.stateObjects[this._current].stateName;

        for (let stateName in itemDiv._stateObjectDivs) {
            let stateObjectDiv = itemDiv._stateObjectDivs[stateName];
            stateObjectDiv.css('display', (stateName == currentStateName) ? '' : 'none');
        }
    }

}
